import { chainConfig, ethereumFacts } from '@morpho-org/viem-dlc/chains'
import { defineChain as viemDefineChain } from 'viem'
import { worldchain as viemWorldchain } from 'viem/chains'

import type { AppChain } from './chain.types'

export const worldchain = viemDefineChain({ ...viemWorldchain, ...chainConfig }).extend({
  viemDlc: ethereumFacts,
  custom: {
    name: 'World Chain',
    shortName: 'World',
    safeShortName: 'wc',
    morphoChainSlug: 'world-chain',
    defiLlamaSlug: 'wc',
    hasFullSupport: true,
    blockExplorer: { baseUrl: 'https://worldscan.org', name: 'Worldscan' },
    contracts: {
      v1: {
        AdaptiveCurveIrm: {
          address: '0x34E99D604751a72cF8d0CFDf87069292d82De472',
          startBlock: 9025669n
        },
        MorphoBlue: { address: '0xE741BC7c34758b4caE05062794E8Ae24978AF432', startBlock: 9025669n },
        MetaMorphoV11Factory: {
          address: '0x4DBB3a642a2146d5413750Cca3647086D9ba5F12',
          startBlock: 9025733n
        }
      },
      v2: {
        VaultV20Factory: {
          address: '0x6846EA318B6B987Ee6b28eBFd87c3409F1d13108',
          startBlock: 20253005n
        },
        MorphoMarketV1AdapterV2Factory: {
          address: '0xEd0b06fcdDB6dD0985e2de9D22ad034d313b7dBd',
          startBlock: 23013012n
        },
        MorphoVaultV1AdapterFactory: {
          address: '0xbF7DEa3756668C7E396C655D646C039826ba8416',
          startBlock: 20253005n
        },
        RegistryList: {
          address: '0x06A47994B4890dcA28C076969cedE1151d86EFCF',
          startBlock: 20253132n
        },
        BluePublicAllocator: {
          address: '0x5Fe47f63ACd84f8A69b97E0a5122fCBff08Df48F',
          startBlock: 33790828n
        }
      }
    }
  }
}) satisfies AppChain<{ v1: true; v2: true }>
